document.addEventListener('DOMContentLoaded', function () {
    if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return;
    }

    if (!window.gsap || !window.ScrollTrigger || !window.ScrollSmoother) {
        console.warn('GSAP / ScrollTrigger / ScrollSmoother not loaded');
        return;
    }

    gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

    // Respect reduced motion setting
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    // --------------------------
    // ScrollTrigger: Hide header on scroll down
    // --------------------------
    ScrollTrigger.create({
        start: "top top",
        end: 99999,
        onUpdate: (self) => {
        const header = document.querySelector('.header');
        if (header) {
            const shouldHideHeader = self.direction === 1; // 1 = scrolling down
            header.classList.toggle("hidden", shouldHideHeader);
        }
        }
    });

    // --------------------------
    // ScrollSmoother
    // --------------------------
    ScrollSmoother.create({
        wrapper: '#smooth-wrapper',     // must exist in theme.liquid
        content: '#smooth-content',     // must exist in theme.liquid
        smooth: 1.7,
        effects: true,
        smoothTouch: 0.1,
        normalizeScroll: true,
    });

    // Refresh on Shopify Theme Editor section changes
    document.addEventListener('shopify:section:load', () => ScrollTrigger.refresh());
    document.addEventListener('shopify:section:reorder', () => ScrollTrigger.refresh());
});
